import React from 'react';
import { ForumTopic } from '../../../../../../types';
import * as S from './styles';
import {
  trackInternalNavigationClick,
  InternalNavigationScope,
} from 'src/globals/tracking/tracking';

type Props = {
  topic: ForumTopic;
};

export const Topic = ({ topic }: Props) => {
  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <S.ForumTopic
      href={topic?.uri ?? ''}
      target="_blank"
      rel="noopener"
      onClick={() => {
        if (topic?.uri)
          trackInternalNavigationClick({
            scope: InternalNavigationScope.FORUM_TOPIC,
            nextPage: topic?.uri,
          });
      }}
    >
      <span>{topic.title}</span>
      <S.LastPost>{topic.lastPost}</S.LastPost>
    </S.ForumTopic>
  );
};
